import { useCallback } from "react";
import { mutateCache, useApi } from "./api";
import { NOTIFICATIONS_URL } from "./useNotifications";
import { InviteProjectData } from "./types/projects";

export const useInvitesApi = () => {
  const api = useApi();

  const refuseSharingInvite = useCallback(
    async (token: string): Promise<void> => {
      await api.postNoResult(`/invites/refuse`, { token });
      mutateCache([`/projects`, `/admin/projects`, NOTIFICATIONS_URL]);
    },
    [api],
  );

  const getProjectData = useCallback(
    async (token: string): Promise<InviteProjectData> => {
      const encodedToken = encodeURIComponent(token);
      const url = `/invites/${encodedToken}/project_data`;
      return api.get<InviteProjectData>({ url, signal: new AbortController().signal });
    },
    [api],
  );

  return {
    refuseSharingInvite,
    getProjectData,
  };
};
